import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import { Avatar, Box, Button, Checkbox, Grid, Typography } from "@mui/material";

import { MainContainer } from "../../content/content.element";
import { allRoleFindAction, allRoleFindWithoutPaginationAction } from "../../../actions/roleMangmentAction.js";
import {
  addEmployeeAction,
  findAllEmployeeAction,
  findAllEmployeewithoutpaginationAction
} from "../../../actions/employeeManagmentAction";
import { InfoHeader } from "../../customComponent/InfoHeader";
import { TypographyText1 } from "../../customComponent/Typography";
import { findBranchMasterAction } from "../../../actions/branchMasterActions";

import "./AddEmployee.css";
import InputField, {
  MultiSelect,
  SelectInputField
} from "../../customComponent/InputField";
import { SubmitButton, SwitchButton } from "../../customComponent/Buttons";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { SUCCESS_TRUE_MSG_ERR } from "../../../constants/roleManagmentConstant.js";
import { countries } from "countries-list";
import axios from "axios";

const AddEmployee = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allRoleFindLoading, allRoleFindSuccess, allRoleFindErr } =
    useSelector((state) => {
      return state.allRoleFind;
    });

  let {
    branchMasterFindLoading,
    branchMasterFindSuccess,
    branchMasterFindErr
  } = useSelector((state) => {
    return state.findBranchMaster;
  });

  let { findEmployeeLoading, findEmployeeSuccess, findEmployeeErr } =
    useSelector((state) => {
      return state.findAllEmployee;
    });

  let { addEmployeeLoading, addEmployeeSuccess, addEmployeeErr } = useSelector(
    (state) => {
      return state.addEmployee;
    }
  );

  const { successAlertMsgSuccess, successAlertMsgErr } = useSelector(
    (state) => {
      return state.successTrueMsg;
    }
  );

  const { findEmployeeWithoutPaginationSuccess } = useSelector((state) => state.findEmployeeWithoutPagination)
  const { allRoleWithoutPaginationSuccess } = useSelector((state) => state.allRoleFindWithoutPagination)

  useEffect(() => {
    if (successAlertMsgSuccess && addEmployeeSuccess) {
      Swal.fire("Good job!", ` Employee added successfully`, "success");
      dispatch(successTrueMsgAction(false));
      setAvatarFile(null);
      setName("");
      setPhone("");
      setEmail("");
      setRole("");
      setAdharNumber("");
      setPanNumber("");
      setPassword("");
      setCPassword("");
      setLocation("");
      setTeamLeadId("");
      setBranch([]);
    }
  }, [successAlertMsgSuccess, addEmployeeSuccess]);

  // useEffect(() => {
  //   if (addEmployeeErr && successAlertMsgErr) {
  //     Swal.fire("error", `${addEmployeeErr}`, "error");
  //     dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
  //   }
  // }, [addEmployeeErr, successAlertMsgErr]);

  useEffect(() => {
    dispatch(findBranchMasterAction());
  }, [dispatch]);

  const [avatarFile, setAvatarFile] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [branch, setBranch] = useState([]);
  const [teamLeadId, setTeamLeadId] = useState("");
  const [isTeamLead, setIsTeamLead] = useState(false);
  const [isLead_B_to_C, setIsLeadBtoC] = useState(false);
  const [isApplicationHandler, setIsApplicationHandler] = useState(false);
  const [isApplicationManager, setIsApplicationManager] = useState(false)
  const [isApplicationTeamLead, setIsApplicationTeamLead] = useState(false)
  const [isUniversityHandler, setIsUniversityHandler] = useState(false);
  const [isTelecallerTeamLead, setIsTelecallerTeamLead] = useState(false);
  const [isTelecallerManager, setIsTelecallerManager] = useState(false);
  const [isTeleCaller, setIsTeleCaller] = useState(false);
  const [isManager, setIsManager] = useState(false);

  const [adharNumber, setAdharNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [location, setLocation] = useState("");
  const [password, setPassword] = useState("");
  const [valid, setValid] = useState(true);
  const [cpassword, setCPassword] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);
  const [allEmplyeeData, setAllEmployeeData] = useState([]);
  const [allBtoCEmployeeData, setAllBtoCEmployeeData] = useState([]);
  const [allTeleCallerLeadData, setAllTeleCallerLeadData] = useState([]);
  const [allTeleCallerManagerData, setAllTeleCallerManagerData] = useState([]);
  const [allApplicationTeamLead, setAllApplicationTeamLead] = useState([])
  const [allApplicationManager, setAllApplicationManager] = useState([])
  const [teamLeadaddBtoCid, setTeamLeadBtoCid] = useState("");
  const [teleCallerTeamLead, setTeleCallerTeamLead] = useState("");
  const [teleCallerManagerId, setTeleCallerManagerId] = useState("");
  const [applicationManager, setApplicationManager] = useState("")
  const [applicationTeamLead, setApplicationTeamLead] = useState("")

  const [countryCode, setCountryCode] = useState("+91");
  const [designation, setDesignation] = useState("");
  const [alreadyAddedEmployee, setAlreadyaddedEmpolyee] = useState(false)

  const allCountries = Object.entries(countries).map(([code, country]) => ({
    value: code,
    label: country.name,
    phone: `+${country.phone}`
  }));

  const [error, setError] = useState({});

  // useEffect(() => {
  //   dispatch(findAllEmployeeAction());
  // }, [dispatch]);  

  useEffect(() => {
    dispatch(findAllEmployeewithoutpaginationAction());
  }, [dispatch]);

  useEffect(() => {
    if (findEmployeeWithoutPaginationSuccess) {
      setAllEmployeeData(findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.is_lead));
      setAllBtoCEmployeeData(
        findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.is_Lead_B_to_C)
      );
      setAllTeleCallerLeadData(
        findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.isTeleCallerTeamLead)
      );
      setAllTeleCallerManagerData(
        findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.isTelecallerManager)
      );
      setAllApplicationTeamLead(
        findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.isApplicationTeamLead)
      )
      setAllApplicationManager(
        findEmployeeWithoutPaginationSuccess?.payload?.filter((user) => user?.isApplicationManager)
      )
    }
  }, [findEmployeeWithoutPaginationSuccess]);

  //hook effect
  // useEffect(() => {
  //   dispatch(allRoleFindAction());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(allRoleFindWithoutPaginationAction());
  }, [dispatch]);

  useEffect(() => {
    if (allRoleWithoutPaginationSuccess) {
      setSuccessAlert(true);
    }
  }, [dispatch]);

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    // Read the image file as a data URL
    reader.readAsDataURL(file);

    // Set the previewImage state when the reader has finished loading the image
    reader.onloadend = () => {
      setAvatarFile(reader.result);
    };
  };

  // password change
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setValid(validatePassword(newPassword));
    setPassword(newPassword);
    setError((prev) => ({
      ...prev,
      ["password"]: ""
    }));
  };

  const validatePassword = (password) => {
    // Check if the password contains at least 6 characters and one symbol
    const regex = /^(?=.*[A-Za-z0-9])(?=.*[!@#$%^&*])[\w!@#$%^&*]{6,}$/;
    return regex.test(password);
  };

  const validate = async () => {
    let errors = {};

    if (!name) {
      errors.name = "Name is required";
    }

    if (!location) {
      errors.location = "Location is required";
    }

    if (phone) {
      if (!/^\d{8,12}$/.test(phone)) {
        errors.phone = "Phone number must be 8 - 12 digits";
      }
    }

    if (!email) {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      errors.email = "Invalid email address";
    } else if (alreadyAddedEmployee) {
      errors.email = "Employee already exists";
    }

    if (!role) {
      errors.role = "Role is required";
    }

    if (!password) {
      errors.password = "Password is required";
    }

    if (!cpassword) {
      errors.cpassword = "Confirm password is required";
    }

    if (!branch || branch.length === 0) {
      errors.branch = "Branch is required";
    }

    setError(errors);
    return Object.keys(errors).length === 0;
  };


  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (password !== cpassword) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Password Do Not Match!"
      });
      return;
    }
    const isValid = await validate();
    if (!isValid) {
      return;
    }

    dispatch(
      addEmployeeAction(
        avatarFile,
        name,
        phone,
        email,
        role,
        adharNumber,
        panNumber,
        password,
        cpassword,
        branch,
        location,
        isTeamLead,
        teamLeadId,
        isTeleCaller,
        isManager,
        isLead_B_to_C,
        isUniversityHandler,
        isApplicationHandler,
        teamLeadaddBtoCid,
        countryCode,
        designation,
        isTelecallerTeamLead,
        teleCallerTeamLead,
        isTelecallerManager,
        teleCallerManagerId,
        isApplicationManager,
        isApplicationTeamLead,
        applicationTeamLead,
        applicationManager
      )
    );
  };

  const handleBranchChange = (event) => {
    // const { value } = event.target;
    // const filteredArray = value;
    setBranch(event);

    setError(false);
  };

  // country Code
  const handleCountryCodeChange = (event) => {
    let value = event.target.value;
    if (value) {
      setCountryCode(value);
    }
  };

  const validateEmail = async (email) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (emailRegex.test(email)) {
        const config = {
          headers: {
            Authorization: `Bearer ${isUserExist?.token}`
          }
        };

        let { data } = await axios.get(
          `/api/admin/employee/employeeemailvalidation?employeeEmail=${email}`,
          config
        );

        if (data.status) {
          setAlreadyaddedEmpolyee(true)
        } else {
          setAlreadyaddedEmpolyee(false)
        }

      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <MainContainer active={props.toggle}>
      <InfoHeader headTitle="Add Employee" url="/Administration" />
      <Box
        sx={{
          width: "100%",
          height: "50px",
          display: "flex",
          alignItems: "center",
          paddingLeft: "16px",
          marginTop: "18px"
        }}
      >
        <TypographyText1 variant="h6" title="Enter Profile Details" />
      </Box>
      <Typography
        sx={{
          fontWeight: 400,
          fontFamily: "'Open Sans', sans-serif",
          color: "rgba(172, 177, 198, 1)",
          ml: 1.5
        }}
      >
        Profile Picture
      </Typography>

      <Box mt={3} mb={5}>
        <Avatar
          src={avatarFile}
          alt="Avatar"
          sx={{ width: 120, height: 120, backgroundColor: "#F4F4F4", m: 1.5 }}
        >
          {!avatarFile && (
            <label htmlFor="avatar-file">
              <img
                src="/menuIcons/fileUploadCenter.png"
                alt="gsl"
                style={{
                  width: 35,
                  height: 35,
                  cursor: "pointer"
                }}
              />
            </label>
          )}
        </Avatar>
        <input
          type="file"
          accept="image/*"
          id="avatar-file"
          style={{ display: "none" }}
          onChange={handleAvatarChange}
        />
        {/* <Typography
          sx={{
            fontSize: "12px",
            color: "#ACB1C6",
          }}
        >
          Please use 1:1 ratio to give best result
        </Typography> */}
      </Box>
      {/* <form onSubmit={handleFormSubmit}> */}
      <Grid container spacing={2}>
        <Grid item lg={6} xs={12}>
          <InputField
            label="Name"
            handleChange={(e) => {
              setName(e.target.value);
              setError((prev) => ({
                ...prev,
                ["name"]: ""
              }));
            }}
            widthSize="98.4%"
            value={name}
            required
            paramses
            InputType="text"
            dispcriptionHeight
            error={Boolean(error?.name)}
            helperText={error?.name}
          />
        </Grid>
        <Grid item xs={0.8}>
          <SelectInputField
            handleSelectChange={handleCountryCodeChange}
            value={countryCode}
            mapValue={allCountries}
            mapMethod="countryCode"
            widthSize="8px"
          />
        </Grid>
        <Grid item lg={5.1} xs={12}>
          <InputField
            label="Phone"
            widthSize="98.4%"
            handleChange={(e) => {
              setPhone(e.target.value);
              setError((prev) => ({
                ...prev,
                ["phone"]: ""
              }));
            }}
            // handleChange={(e) => {
            //   if (/^\d{0,16}$/.test(e.target.value)) {
            //     /^\d{0,9}$/.test(e.target.value)
            //       ? setPhoneError(true)
            //       : setPhoneError(false);
            //     setPhone(e.target.value);
            //   } else {
            //     setPhoneError(false);
            //   }
            // }}
            // required
            value={phone}
            InputType="number"
            error={Boolean(error?.phone)}
            helperText={error?.phone}
          />
          {/* {phoneError ? (
              <span
                style={{
                  color: "red",
                  fontSize: "13px",
                  fontWeight: 300,
                  paddingTop: "-20px",
                }}
              >
                Please Enter Atleast 10 Numbers
              </span>
            ) : null} */}
        </Grid>
        <Grid item lg={6} xs={12}>
          <InputField
            label="Email"
            handleChange={async (e) => {
              setEmail(e.target.value);

              const response = await validateEmail(e.target.value)

              setError((prev) => ({
                ...prev,
                ["email"]: ""
              }));
            }}
            required
            value={email}
            widthSize="98.4%"
            error={Boolean(error?.email)}
            helperText={error?.email}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <SelectInputField
            label="Role"
            handleSelectChange={(e) => {
              setRole(e.target.value);
              setError((prev) => ({
                ...prev,
                ["role"]: ""
              }));
            }}
            widthSize="32px"
            value={role}
            mapValue={allRoleWithoutPaginationSuccess?.payload}
            mapMethod="role"
            required={true}
          />

          <span
            style={{
              color: "#FF2400",
              fontSize: "12px"
            }}
          >
            {error?.role}
          </span>
        </Grid>

        <Grid item lg={6} xs={12}>
          <InputField
            label="Designation"
            handleChange={(e) => {
              setDesignation(e.target.value);
            }}
            value={designation}
            widthSize="98.4%"
          // error={Boolean(error?.adharNumber)}
          // helperText={error?.adharNumber}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <InputField
            label="Adhar Number"
            handleChange={(e) => {
              setAdharNumber(e.target.value);
              setError((prev) => ({
                ...prev,
                ["adharNumber"]: ""
              }));
            }}
            value={adharNumber}
            widthSize="98.4%"
          // error={Boolean(error?.adharNumber)}
          // helperText={error?.adharNumber}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <InputField
            label="Pan Number"
            handleChange={(e) => {
              setPanNumber(e.target.value);
              setError((prev) => ({
                ...prev,
                ["panNumber"]: ""
              }));
            }}
            value={panNumber}
            widthSize="98.4%"
          // error={Boolean(error?.panNumber)}
          // helperText={error?.panNumber}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <InputField
            label="Location"
            handleChange={(e) => {
              setLocation(e.target.value);
              setError((prev) => ({
                ...prev,
                ["location"]: ""
              }));
            }}
            widthSize="98.4%"
            value={location}
            required
            paramses
            InputType="text"
            dispcriptionHeight
            error={Boolean(error?.location)}
            helperText={error?.location}
          />
        </Grid>

        {/* <Grid item lg={6} xs={12}>
          <SelectInputField
            label="Branch"
            handleSelectChange={(e) => setBranch(e.target.value)}
            widthSize="49px"
            value={branch}
            mapValue={branchMasterFindSuccess}
            mapMethod="branch"
          />
        </Grid> */}

        <Grid item lg={6} xs={12}>
          <SelectInputField
            label="Branch"
            handleSelectChange={handleBranchChange}
            widthSize="49px"
            value={branch}
            mapValue={branchMasterFindSuccess}
            mapMethod="branchMaster"
            multiple="true"
            required={true}
          />
          <span
            style={{
              color: "#FF2400",
              fontSize: "12px"
            }}
          >
            {error?.branch}
          </span>
          {/* <MultiSelect /> */}
          {/* {rankError ? (
            <p style={{ color: "red", margin: 0, padding: 0 }}>
              Please Select Rank
            </p>
          ) : null} */}
        </Grid>

        {!isTeamLead && (
          <Grid item xs={12}>
            <SelectInputField
              label="Choose B2B lead"
              handleSelectChange={(e) => setTeamLeadId(e.target.value)}
              widthSize="49px"
              value={teamLeadId}
              mapValue={allEmplyeeData}
              mapMethod="teams"
            />
          </Grid>
        )}

        {!isLead_B_to_C && (
          <Grid item xs={12}>
            <SelectInputField
              label="Choose B2C lead"
              handleSelectChange={(e) => setTeamLeadBtoCid(e.target.value)}
              widthSize="49px"
              value={teamLeadaddBtoCid}
              mapValue={allBtoCEmployeeData}
              mapMethod="teams"
            />
          </Grid>
        )}

        {!isTelecallerManager && (
          <Grid item xs={12}>
            <SelectInputField
              label="Choose Telecaller Manager"
              handleSelectChange={(e) => setTeleCallerManagerId(e.target.value)}
              widthSize="49px"
              value={teleCallerManagerId}
              mapValue={allTeleCallerManagerData}
              mapMethod="teams"
            />
          </Grid>
        )}

        {!isTelecallerTeamLead && (
          <Grid item xs={12}>
            <SelectInputField
              label="Choose Telecaller Team Lead"
              handleSelectChange={(e) => setTeleCallerTeamLead(e.target.value)}
              widthSize="49px"
              value={teleCallerTeamLead}
              mapValue={allTeleCallerLeadData}
              mapMethod="teams"
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <SelectInputField
            label="Choose Application Manager"
            handleSelectChange={(e) => setApplicationManager(e.target.value)}
            widthSize="49px"
            value={applicationManager}
            mapValue={allApplicationManager}
            mapMethod="teams"
          />
        </Grid>

        <Grid item xs={12}>
          <SelectInputField
            label="Choose Application Team Lead"
            handleSelectChange={(e) => setApplicationTeamLead(e.target.value)}
            widthSize="49px"
            value={applicationTeamLead}
            mapValue={allApplicationTeamLead}
            mapMethod="teams"
          />
        </Grid>

        <Grid item xs={12} mt={-1}>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Team Lead B2B
              </Typography>
              <Checkbox
                checked={isTeamLead}
                onChange={(e) => {
                  setIsTeamLead(e.target.checked);
                  setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            {/* <SwitchButton label="Team Lead" /> */}

            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Manager
              </Typography>
              <Checkbox
                checked={isManager}
                onChange={(e) => {
                  setIsManager(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Team Lead B2C
              </Typography>
              <Checkbox
                checked={isLead_B_to_C}
                onChange={(e) => {
                  setIsLeadBtoC(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Application handler
              </Typography>
              <Checkbox
                checked={isApplicationHandler}
                onChange={(e) => {
                  setIsApplicationHandler(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Application Manager
              </Typography>
              <Checkbox
                checked={isApplicationManager}
                onChange={(e) => {
                  setIsApplicationManager(e.target.checked);
                  setIsApplicationTeamLead(false)
                  setIsApplicationHandler(e.target.checked)
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                Application Team Lead
              </Typography>
              <Checkbox
                checked={isApplicationTeamLead}
                onChange={(e) => {
                  setIsApplicationTeamLead(e.target.checked);
                  setIsApplicationManager(false)
                  setIsApplicationHandler(e.target.checked)
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                University handler
              </Typography>
              <Checkbox
                checked={isUniversityHandler}
                onChange={(e) => {
                  setIsUniversityHandler(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                TeleCaller
              </Typography>
              <Checkbox
                checked={isTeleCaller}
                onChange={(e) => {
                  setIsTeleCaller(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                TeleCaller Manager
              </Typography>
              <Checkbox
                checked={isTelecallerManager}
                onChange={(e) => {
                  setIsTelecallerManager(e.target.checked);
                  setIsTelecallerTeamLead(false);
                  setIsTeleCaller(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "rgba(138, 146, 166, 1)"
                }}
              >
                TeleCaller Team Lead
              </Typography>
              <Checkbox
                checked={isTelecallerTeamLead}
                onChange={(e) => {
                  setIsTelecallerTeamLead(e.target.checked);
                  setIsTelecallerManager(false)
                  setIsTeleCaller(e.target.checked);
                  // setTeamLeadId("");
                }}
                style={{ color: "#f81b82" }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          width: "100%",
          height: "50px",
          display: "flex",
          alignItems: "center",
          marginTop: "30px"
        }}
      >
        <TypographyText1 variant="h6" title="Login Details" />
      </Box>

      <Grid container spacing={2}>
        <Grid item lg={6} xs={12}>
          <InputField
            label="New Password"
            handleChange={handlePasswordChange}
            value={password}
            widthSize="99%"
            error={Boolean(error?.password)}
            helperText={error?.password}
          />
          {!valid && (
            <span
              style={{
                color: "red",
                fontSize: "14px",
                fontWeight: 300,
                paddingTop: "-20px"
              }}
            >
              Password must have at least 6 characters and contain at least one
              symbol (!@#$%^&*)
            </span>
          )}
        </Grid>

        <Grid item lg={6} xs={12}>
          <InputField
            label="Confirm Password"
            handleChange={(e) => {
              setCPassword(e.target.value);
            }}
            value={cpassword}
            widthSize="99%"
            error={Boolean(error?.cpassword)}
            helperText={error?.cpassword}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ textAlign: "right", mb: 2 }}>
        <SubmitButton
          title="Save"
          submit="submit"
          widthSize="75px"
          heightSize="42px"
          type="click"
          handleSubmit={handleFormSubmit}
        />
      </Grid>
      {/* </form> */}
    </MainContainer>
  );
};

export default AddEmployee;
